import React, { useState } from "react";
import { PerformanceNavbar } from "./reusedcomponent/navbar";
import Modal from "react-modal";

const customStyles = {
  content: {
    top: "40%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-60%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll",
  },
};

export const HistoryReview = () => {
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalopen, Setmodalopen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
  };

  function toggle() {
    Setmodalopen(!modalopen);
  }

  return (
    <React.Fragment>
      <PerformanceNavbar />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="view user datails modal"
      />

      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="m-t-30 m-b-30">
                <div className="row">
                  <div className="col-md-4">
                    <div className="card-box-six text-center">
                      <button
                        className="btn p-3"
                        onClick={() => {
                          setIsOpen(true);
                          setUser(user);
                        }}
                      >
                        Review 2020 &nbsp;&nbsp;{" "}
                        <span class="fa fa-spinner"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/perfomancemanagement/history_review.js